// export const BASE_URL =
//   process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : '';
export const BASE_URL = ''; // If using proxy
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const CHECKOUT_URL = '/api/checkout';
export const UPLOAD_URL = '/api/upload';
export const PROMO_CODES_URL = '/api/promocodes';

// Keep in sync with backend/utils/calcPrices.js
export const FREE_SHIPPING_THRESHOLD = 25;
export const STANDARD_SHIPPING = 3.99;
export const NEXT_DAY_SHIPPING = 4.99;
